import { ActionTypes } from "../constants/action_types";

export const addAuthToken = (value) => {
    return {
        type: ActionTypes.ADD_AUTHTOKEN,
        token: value,
    }
}

export const removeAuthToken = (value) => {
    return {
        type: ActionTypes.REMOVE_AUTHTOKEN,
        token: value,
    }
}
